import { HERO_CTA, HERO_SUBTITLE, HERO_TITLE } from '@/content/copy';

export function Hero() {
  return (
    <section className="hero section">
      <div className="hero-badge">Bitcoin Pizza Day • Since 22 May 2010</div>
      <h1>{HERO_TITLE}</h1>
      <p>{HERO_SUBTITLE}</p>
      <a href="#chart" className="btn primary">
        {HERO_CTA}
      </a>
    </section>
  );
}
